analytics.eventConfig.push(
//    {
//     "target": ".imageCard--card", //image  Cards
//     "events": [
//         {
//             "eventTarget": ".imageCard--overlay .cta-button a.button-primary",
//             "eventType": "click",
//             "tags": {
//                 "event": "componentInteraction",
//                 "componentType": "Image Cards",
//                 "interactionType": "click", // possible values: click, videoPlay 
//                 "elementClicked": "button", // possible values: link, button, video
//                 "contentTitle": "",
//                 "destinationURL": "",
//                 "elementText": ""
//             }
//         },
//         {
//             "eventTarget": ".imageCard--overlay .cta-button a.button-secondary",
//             "eventType": "click",
//             "tags": {
//                 "event": "componentInteraction",
//                 "componentType": "Image Cards",
//                 "interactionType": "click", // possible values: click, videoPlay 
//                 "elementClicked": "button", // possible values: link, button, video
//                 "contentTitle": "",
//                 "destinationURL": "",
//                 "elementText": ""
//             }
//         },
//         {
//             "eventTarget": ".imageCard--overlay .cta-button a.button-secondary-white",
//             "eventType": "click",
//             "tags": {
//                 "event": "componentInteraction",
//                 "componentType": "Image Cards",
//                 "interactionType": "click", // possible values: click, videoPlay 
//                 "elementClicked": "button", // possible values: link, button, video
//                 "contentTitle": "",
//                 "destinationURL": "",
//                 "elementText": ""
//             }
//         },
//         {
//             "eventTarget": ".imageCard--overlay .cta-button a.button-tertiary",
//             "eventType": "click",
//             "tags": {
//                 "event": "componentInteraction",
//                 "componentType": "Image Cards",
//                 "interactionType": "click", // possible values: click, videoPlay 
//                 "elementClicked": "link", // possible values: link, button, video
//                 "contentTitle": "",
//                 "destinationURL": "",
//                 "elementText": ""
//             }
//         },
//         {
//             "eventTarget": ".imageCard--overlay .cta-button-popup-modal a.button-primary",
//             "eventType": "click",
//             "tags": {
//                 "event": "componentInteraction",
//                 "componentType": "Image Cards",
//                 "interactionType": "click", // possible values: click, videoPlay 
//                 "elementClicked": "button", // possible values: link, button, video
//                 "contentTitle": "",
//                 "destinationURL": "",
//                 "elementText": ""
//             }
//         },
//         {
//             "eventTarget": ".imageCard--overlay .cta-button-popup-modal a.button-secondary",
//             "eventType": "click",
//             "tags": {
//                 "event": "componentInteraction",
//                 "componentType": "Image Cards",
//                 "interactionType": "click", // possible values: click, videoPlay 
//                 "elementClicked": "button", // possible values: link, button, video
//                 "contentTitle": "",
//                 "destinationURL": "",
//                 "elementText": ""
//             }
//         },
//         {
//             "eventTarget": ".imageCard--overlay .cta-button-popup-modal a.button-secondary-white",
//             "eventType": "click",
//             "tags": {
//                 "event": "componentInteraction",
//                 "componentType": "Image Cards",
//                 "interactionType": "click", // possible values: click, videoPlay 
//                 "elementClicked": "button", // possible values: link, button, video
//                 "contentTitle": "",
//                 "destinationURL": "",
//                 "elementText": ""
//             }
//         },
//         {
//             "eventTarget": ".imageCard--overlay .cta-button-popup-modal a.button-tertiary",
//             "eventType": "click",
//             "tags": {
//                 "event": "componentInteraction",
//                 "componentType": "Image Cards",
//                 "interactionType": "click", // possible values: click, videoPlay 
//                 "elementClicked": "link", // possible values: link, button, video
//                 "contentTitle": "",
//                 "destinationURL": "",
//                 "elementText": ""
//             }
//         },
//     ]},
        {
            "target": ".imageCard--surface-item", //image  Cards
            "events": [
                {
                    "eventTarget": ".imageCard--overlay .cta-button a.button-primary",
                    "eventType": "click",
                    "tags": {
                        "event": "componentInteraction",
                        "componentType": "Image Cards",
                        "interactionType": "click", // possible values: click, videoPlay 
                        "elementClicked": "button", // possible values: link, button, video
                        "contentTitle": "",
                        "destinationURL": "",
                         "elementText": ""
                    }
                },
                {
                    "eventTarget": ".imageCard--overlay .cta-button a.button-secondary",
                    "eventType": "click",
                    "tags": {
                        "event": "componentInteraction",
                        "componentType": "Image Cards",
                        "interactionType": "click", // possible values: click, videoPlay 
                        "elementClicked": "button", // possible values: link, button, video
                        "contentTitle": "",
                        "destinationURL": "",
                         "elementText": ""
                    }
                },
                {
                    "eventTarget": ".imageCard--overlay .cta-button a.button-secondary-white",
                    "eventType": "click",
                    "tags": {
                        "event": "componentInteraction",
                        "componentType": "Image Cards",
                        "interactionType": "click", // possible values: click, videoPlay 
                        "elementClicked": "button", // possible values: link, button, video
                        "contentTitle": "",
                        "destinationURL": "",
                         "elementText": ""
                    }
                },
                {
                    "eventTarget": ".imageCard--overlay .cta-button a.button-tertiary",
                    "eventType": "click",
                    "tags": {
                        "event": "componentInteraction",
                        "componentType": "Image Cards",
                        "interactionType": "click", // possible values: click, videoPlay 
                        "elementClicked": "link", // possible values: link, button, video
                        "contentTitle": "",
                        "destinationURL": "",
                         "elementText": ""
                    }
                },
                {
                    "eventTarget": ".imageCard--overlay .cta-button-popup-modal a.button-primary",
                    "eventType": "click",
                    "tags": {
                        "event": "componentInteraction",
                        "componentType": "Image Cards",
                        "interactionType": "click", // possible values: click, videoPlay 
                        "elementClicked": "button", // possible values: link, button, video
                        "contentTitle": "",
                        "destinationURL": "",
                         "elementText": ""
                    }
                },
                {
                    "eventTarget": ".imageCard--overlay .cta-button-popup-modal a.button-secondary",
                    "eventType": "click",
                    "tags": {
                        "event": "componentInteraction",
                        "componentType": "Image Cards",
                        "interactionType": "click", // possible values: click, videoPlay 
                        "elementClicked": "button", // possible values: link, button, video
                        "contentTitle": "",
                        "destinationURL": "",
                         "elementText": ""
                    }
                },
                {
                    "eventTarget": ".imageCard--overlay .cta-button-popup-modal a.button-secondary-white",
                    "eventType": "click",
                    "tags": {
                        "event": "componentInteraction",
                        "componentType": "Image Cards",
                        "interactionType": "click", // possible values: click, videoPlay 
                        "elementClicked": "button", // possible values: link, button, video
                        "contentTitle": "",
                        "destinationURL": "",
                         "elementText": ""
                    }
                },
                {
                    "eventTarget": ".imageCard--overlay .cta-button-popup-modal a.button-tertiary",
                    "eventType": "click",
                    "tags": {
                        "event": "componentInteraction",
                        "componentType": "Image Cards",
                        "interactionType": "click", // possible values: click, videoPlay 
                        "elementClicked": "link", // possible values: link, button, video
                        "contentTitle": "",
                        "destinationURL": "",
                         "elementText": ""
                    }
                },
                {
                    "eventTarget": ".heading-section__cta a.button-tertiary",
                    "eventType": "click",
                    "tags": {
                        "event": "componentInteraction",
                        "componentType": "Image Cards",
                        "interactionType": "click", // possible values: click, videoPlay 
                        "elementClicked": "link", // possible values: link, button, video
                        "contentTitle": "",
                        "destinationURL": "",
                         "elementText": ""
                    }
                },
                {
                    "eventTarget": ".heading-section__cta a.button-tertiary--white",
                    "eventType": "click",
                    "tags": {
                        "event": "componentInteraction",
                        "componentType": "Image Cards",
                        "interactionType": "click", // possible values: click, videoPlay 
                        "elementClicked": "link", // possible values: link, button, video
                        "contentTitle": "",
                        "destinationURL": "",
                         "elementText": ""
                    }
                }
          ]
    }
);
